import React            from 'react';
import { formatOption } from '../../../../util';
import { SelectField }  from '../../../components/forms';
import { TIME_UNITS }   from '../../../../constants/TimeEnums';

const Dropdown = ( { pluralize = false, ...props } ) => {
	
	let options = [
		formatOption( TIME_UNITS.DAYS, 'Days' ),
		formatOption( TIME_UNITS.WEEKS, 'Weeks' ),
		formatOption( TIME_UNITS.MONTHS, 'Months' ),
		formatOption( TIME_UNITS.YEARS, 'Years' ),
	];
	
	return (
		<SelectField
			{ ...props }
			dictionary={ !pluralize ? new Map( [
				[ TIME_UNITS.DAYS, 'Day' ],
				[ TIME_UNITS.WEEKS, 'Week' ],
				[ TIME_UNITS.MONTHS, 'Month' ],
				[ TIME_UNITS.YEARS, 'Year' ],
			] ) : null }
			options={ options }>
		</SelectField>
	);
};

export { Dropdown as TimeUnitsDropdown };
